export default __webpack_public_path__ + "static/media/logo_ícono_transparente.81382e80.png";